import catalog from './apiStandartsCatalog'

export default {
  ...catalog,
}
